if (!customElements.get('product-mobile-zoom')) {
  customElements.define(
    'product-mobile-zoom',
    class ProductMobileZoom extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(max-width: 749px)');
        this.boundOpen = this.handleOpen.bind(this);
        this.boundBindOpeners = this.bindOpeners.bind(this);
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.currentIndex = 0;
      }

      connectedCallback() {
        this.mainImg = this.querySelector('.product-mobile-zoom-modal__img');
        this.mainContainer = this.querySelector('.product-mobile-zoom-modal__main');
        this.thumbs = this.querySelectorAll('.product-mobile-zoom-modal__thumb');
        this.backBtn = this.querySelector('.product-mobile-zoom-modal__back');

        this.boundClose = () => this.close();
        this.boundBackdropClick = (e) => { if (e.target === this) this.close(); };
        this.boundKeydown = (e) => {
          if (e.key === 'Escape') this.close();
          if (e.key === 'ArrowLeft') this.prev();
          if (e.key === 'ArrowRight') this.next();
        };
        this.boundTouchStart = (e) => { this.touchStartX = e.changedTouches[0].screenX; };
        this.boundTouchEnd = (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        };

        this.backBtn?.addEventListener('click', this.boundClose);
        this.addEventListener('click', this.boundBackdropClick);
        this.addEventListener('keydown', this.boundKeydown);
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActive(thumb.dataset.mediaId));
        });

        this.mainContainer?.addEventListener('touchstart', this.boundTouchStart, { passive: true });
        this.mainContainer?.addEventListener('touchend', this.boundTouchEnd, { passive: true });

        this.bindOpeners();
        this.mql.addEventListener('change', this.boundBindOpeners);
      }

      disconnectedCallback() {
        this.mql.removeEventListener('change', this.boundBindOpeners);
        this.backBtn?.removeEventListener('click', this.boundClose);
        this.removeEventListener('click', this.boundBackdropClick);
        this.removeEventListener('keydown', this.boundKeydown);
        this.mainContainer?.removeEventListener('touchstart', this.boundTouchStart);
        this.mainContainer?.removeEventListener('touchend', this.boundTouchEnd);
      }

      bindOpeners() {
        const sectionId = this.dataset.sectionId;
        const section = document.getElementById('MainProduct-' + sectionId);
        if (!section) return;

        section.querySelectorAll('modal-opener[data-modal*="ProductModal"] .product__media-toggle[data-media-id]').forEach((btn) => {
          btn.removeEventListener('click', this.boundOpen, true);
          btn.addEventListener('click', this.boundOpen, true);
        });
      }

      handleOpen(e) {
        if (!this.mql.matches) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.open(e.currentTarget.dataset.mediaId);
      }

      setActive(mediaId) {
        const thumb = this.querySelector('[data-media-id="' + mediaId + '"]');
        if (!thumb) return;

        this.thumbs.forEach((t, index) => {
          const isActive = t === thumb;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) this.currentIndex = index;
        });
        this.mainImg.src = thumb.dataset.src;
        this.mainImg.alt = thumb.dataset.alt || '';
        thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }

      open(mediaId) {
        const targetId = mediaId || this.thumbs[0]?.dataset.mediaId;
        if (!targetId) return;

        this.setActive(targetId);
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }

      close() {
        const scrollTarget = this.getScrollTarget();
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus();
        if (scrollTarget) scrollTarget.slider.scrollLeft = scrollTarget.offset;
      }

      getScrollTarget() {
        const sectionId = this.dataset.sectionId;
        const activeThumb = this.thumbs[this.currentIndex];
        if (!activeThumb) return null;

        const mediaId = activeThumb.dataset.mediaId;
        const fullMediaId = sectionId + '-' + mediaId;
        const slider = document.getElementById('Slider-Gallery-' + sectionId);
        if (!slider) return null;

        const slides = Array.from(slider.querySelectorAll('[data-media-id]'));
        const targetSlide = slides.find((s) => s.dataset.mediaId === fullMediaId);
        if (!targetSlide) return null;

        slides.forEach((slide) => slide.classList.remove('is-active'));
        targetSlide.classList.add('is-active');

        return { slider, offset: targetSlide.offsetLeft };
      }


      handleSwipe() {
        const diff = this.touchStartX - this.touchEndX;
        const threshold = 50;
        if (Math.abs(diff) < threshold) return;
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }

      next() {
        const nextIndex = Math.min(this.currentIndex + 1, this.thumbs.length - 1);
        if (nextIndex !== this.currentIndex) {
          this.setActive(this.thumbs[nextIndex].dataset.mediaId);
        }
      }

      prev() {
        const prevIndex = Math.max(this.currentIndex - 1, 0);
        if (prevIndex !== this.currentIndex) {
          this.setActive(this.thumbs[prevIndex].dataset.mediaId);
        }
      }
    }
  );
}
